
import React from 'react'
import Page from '../components/Page'
import { IonCheckbox, IonLabel, IonButton, IonItem, IonList } from '@ionic/react'
import runes from '../data/runes'
import getRunewordsByRunes from '../utils/getRunewordsByRunes';

const lowRunes = Object.keys(runes).filter(k => !(runes[k].level > 25));
const mediumRunes = Object.keys(runes).filter(k => !(runes[k].level > 50) && runes[k].level > 25 )
const highRunes = Object.keys(runes).filter(k => runes[k].level > 50 )

const initialState = {
  allLowSelected: false,
  allMediumSelected: false,
  allHighSelected: false
}

export default class extends React.Component {

  state = initialState

  renderAmountPossibleButton() {
    let arr = Object.keys(this.state);
    let filtered = arr.filter(e => this.state[e]);
    const runewords = getRunewordsByRunes(filtered);
    window.foundRunewords = runewords;
    return (
      <IonButton className="d2font" size="large" disabled={runewords.length == 0} routerLink="/finderResults">
        {runewords.length} runewords found
      </IonButton>
    )
  }

  render() {

    return (
      <Page title="Select runes" padding>

          {this.renderAmountPossibleButton()}
          <br />        
          <br />        

          <b>Low Runes</b> 
          <IonButton size="small" style={{marginLeft: 20, marginBottom: 12}} onClick={() => {
            let modifier = {}
            lowRunes.forEach(r => {
              modifier[r] = this.state.allLowSelected ? false: true;
            })
            this.setState(modifier);
            this.setState({allLowSelected: !this.state.allLowSelected})
          }}>{this.state.allLowSelected ? 'unselect' : 'select'} all</IonButton>

          <br />        
          <div>
            {lowRunes.map((r,i) => 
              <div key={r} style={{width: 90, display: 'inline-block'}}>
                <IonCheckbox mode="ios" onIonChange={e => {
                  let modifier = {};
                  modifier[r] = e.target.checked;
                  this.setState(modifier);
                }} style={{top: 7, margin: '0 5px 0 0'}} checked={this.state[r]} />
                <span>{r}</span>
              </div> 
              )}
          </div>

          <br />        
          <br />        
          <br />        

          <b>Medium Runes</b> 
          <IonButton size="small" style={{marginLeft: 20, marginBottom: 12}} onClick={() => {
            let modifier = {}
            mediumRunes.forEach(r => {
              modifier[r] = this.state.allMediumSelected ? false: true;
            })
            this.setState(modifier);
            this.setState({allMediumSelected: !this.state.allMediumSelected})
          }}>{this.state.allMediumSelected ? 'unselect' : 'select'} all</IonButton>

          <br />        
        
        {mediumRunes.map((r,i) => 
          <div key={r} style={{width: 90, display: 'inline-block'}}>
              <IonCheckbox mode="ios" onIonChange={e => {
              let modifier = {};
              modifier[r] = e.target.checked;
              this.setState(modifier);
            }} style={{top: 7, margin: '0 5px 0 0'}} checked={this.state[r]} />
            <span>{r}</span>
          </div>
          )}


          <br />        
          <br />        
          <br />        

          <b>High runes</b> 
          <IonButton size="small" style={{marginLeft: 20, marginBottom: 12}} onClick={() => {
            let modifier = {}
            highRunes.forEach(r => {
              modifier[r] = this.state.allHighSelected ? false: true;
            })
            this.setState(modifier);
            this.setState({allHighSelected: !this.state.allHighSelected})
          }}>{this.state.allHighSelected ? 'unselect' : 'select'} all</IonButton>

          <br />
        
        {highRunes.map((r,i) => 
          <div key={r} style={{width: 90, display: 'inline-block'}}>
              <IonCheckbox mode="ios" onIonChange={e => {
              let modifier = {};
              modifier[r] = e.target.checked;
              this.setState(modifier);
            }} style={{top: 7, margin: '0 5px 0 0'}} checked={this.state[r]} />
            <span>{r}</span>
          </div>
          )}
          <br />
          <br />
          <br />
          <IonButton onClick={() => {
            const str = JSON.stringify(this.state);
            localStorage.setItem('savedRunes',str);
            alert('selection saved.');
          }}>Save selection</IonButton>
          <IonButton onClick={() => {
            if(!localStorage.getItem('savedRunes')) {
              alert('you dont have any runes saved yet');
              return;
            }
            const saved = JSON.parse(localStorage.getItem('savedRunes'));
            Object.keys(this.state).forEach(key => {
              let modifier = {};
              modifier[key] = undefined;
              this.setState(modifier)
            })
            this.setState(saved)
          }}>Load saved</IonButton>

      </Page>
    )
  }
}